'use client'

import React, { useRef } from 'react'
import { useTranslations } from 'next-intl'
import { MaterialIcon } from '@/components/ui/MaterialIcon'

interface FileDropZoneProps {
    accept: string
    icon: string
    title: string
    subtitle: string
    onFilesAdded: (files: File[]) => void
    multiple?: boolean
}

export function FileDropZone({ accept, icon, title, subtitle, onFilesAdded, multiple = true }: FileDropZoneProps) {
    const t = useTranslations('FileDropZone')
    const fileInputRef = useRef<HTMLInputElement>(null)

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            onFilesAdded(Array.from(e.target.files))
        }
        if (fileInputRef.current) fileInputRef.current.value = ''
    }

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onFilesAdded(Array.from(e.dataTransfer.files))
        }
    }

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                accept={accept}
                multiple={multiple}
                title={title}
            />
            <div
                className="group relative flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50/50 py-16 text-center transition-all hover:border-primary/50 hover:bg-slate-50"
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <MaterialIcon name={icon} className="text-4xl" />
                </div>
                <p className="mb-1 text-xl font-bold text-slate-900">{title}</p>
                <p className="mb-8 text-sm text-slate-500">{subtitle}</p>
                <div className="flex flex-wrap justify-center gap-6">
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                        <MaterialIcon name="bolt" className="text-lg" /> {t('freeAndFast')}
                    </div>
                </div>
            </div>
        </>
    )
}
